import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { log } from "@/lib/log";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const u = await auth.emergentSession(sessionId);
        setUser(u);
        // strip the hash
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: u } });
      } catch (e) {
        log.error("Emergent auth failed", e);
        navigate("/login?error=oauth", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-rp-bg">
      <div className="text-rp-textDim font-mono text-xs tracking-[0.2em] uppercase">
        Completing sign-in…
      </div>
    </div>
  );
}
